import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { useNavigate } from "react-router";
import { Aperture } from "@gravity-ui/icons";
import { PageLayoutAside } from "@gravity-ui/navigation";
import { RoutesList } from "@/router/routesList";
export var DesktopNavigation = function (props) {
    var navigate = useNavigate();
    var homeClickHandler = function (event) {
        event.preventDefault();
        navigate(RoutesList.Root);
    };
    return (_jsx(PageLayoutAside, { logo: {
            text: "Placer",
            icon: Aperture,
            onClick: homeClickHandler,
        }, menuItems: props.data, onChangeCompact: props.onSwitch }));
};
